import React, { Component } from 'react'
import CardPartido from '../CardPartido'
import './_styles.scss'
import Asset from '../../../../../requests/apa/Asset'
import Utils from '../../../../../utils/Utils'
import Translator from '../../../../../requests/apa/Translator'
import { FINAL, TERCER_LUGAR } from '../.././../constants'

class SemifinalContent extends Component {
  renderSingleMatch(matches) {
    const { path, liveEventsMap = {}, liveScoresMap = {} } = this.props
    const match = matches && matches[0]

    return match && (
      <CardPartido
          time={match.time}
          timezone={match.timezone}
          homeTeam={match.homeTeam}
          awayTeam={match.awayTeam}
          venue={match.venue}
          matchId={match.id}
          status={match.status}
          scheduledAt={match.scheduledAt}
          date={match.scheduledAt}
          liveEvents={liveEventsMap[match.id]}
          liveScore={liveScoresMap[match.id]}
          path={path}
          liveEvents={liveEventsMap[match.id]}
          liveScore={liveScoresMap[match.id]}
      />
    )
  }

  renderMatches(round) {
    const { path, liveEventsMap = {}, liveScoresMap = {} } = this.props
    if (!round || !Array.isArray(round) || round.length < 1) return null

    return round && round.map((item, index) => {
      const match = item
      return (
        <div className='semifinal-content__match-wrapper' key={index}>
          { match && (
              <CardPartido
                time={match.time}
                timezone={match.timezone}
                homeTeam={match.homeTeam}
                awayTeam={match.awayTeam}
                matchId={match.id}
                venue={match.venue}
                status={match.status}
                scheduledAt={match.scheduledAt}
                broadcast={match.broadcast}
                matchProgress={match.matchProgress}
                date={match.scheduledAt}
                liveEvents={liveEventsMap[match.id]}
                liveScore={liveScoresMap[match.id]}
                path={path}
                liveEvents={liveEventsMap[match.id]}
                liveScore={liveScoresMap[match.id]}
              />
          )}
        </div>
      )
    })
  }

  render () {
    const { phase = '', matches = [], finalMatch = [], thirdPlaceMatch = [] } = this.props

    return (
      <div className='semifinal-content'>
        {/* ── Horizontal lines ── */}
        <div className='semifinal-content__line-horizontal--first'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>
        <div className='semifinal-content__line-horizontal--second'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>

        {/* ── Left column: 2 Semifinal cards ── */}
        <div className='semifinal-content__col semifinal-content__col--left'>
          <div className='semifinal-content__col-header'>
            <span className='semifinal-content__col-title'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo1_${phase}`),22)}</span>
          </div>
          <div className='semifinal-content__matches'>
            { this.renderMatches(matches) }
          </div>
        </div>

        <div className='semifinal-content__bracket'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_corchete2', '')} />
        </div>

        {/* ── Right top column: Final ── */}
        <div className='semifinal-content__col semifinal-content__col--right-top'>
          <div className='semifinal-content__col-header'>
            <span className='semifinal-content__col-title'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo2_${FINAL}`),22)}</span>
          </div>
          <div className='semifinal-content__matches'>
            <div className='semifinal-content__match-wrapper'>
                { this.renderSingleMatch(finalMatch) }
            </div>
          </div>
        </div>

        {/* ── Right bottom column: 3° lugar ── */}
        <div className='semifinal-content__col semifinal-content__col--right-bottom'>
            <div className='semifinal-content__col-header'>
                <span className='semifinal-content__col-title'>{Utils.cutPlayerString(Translator.get(`eventodeportivo_carruseletapas_texto_titulo3_${TERCER_LUGAR}`),22)}</span>
            </div>
            <div className='semifinal-content__match-wrapper'>
              { this.renderSingleMatch(thirdPlaceMatch) }
            </div>
        </div>

        {/* ── Horizontal line ── */}
        <div className='semifinal-content__line-horizontal--last'>
            <img src={Asset.get('eventodeportivo_carruseletapas_imagen_linea', '')} />
        </div>

      </div>
    )
  }
}

export default SemifinalContent


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/SemifinalContent/index.jsx